'use client';
import Image from 'next/image';   
import { useState, useEffect } from 'react';
import { FaAngleDown } from "react-icons/fa6";
import { useRouter } from 'next/navigation';

import brand1 from '../../public/image 22.png';
import brand2 from '../../public/image 23.png';
import brand3 from '../../public/image 24.png';
import brand4 from '../../public/image 25.png';
import brand5 from '../../public/image 26.png';
import brand6 from '../../public/image 27.png';
import brand7 from '../../public/image 28.png';
import brand8 from '../../public/image 35.png';
import brand9 from '../../public/image 36.png';
import brand10 from '../../public/image 37.png';
import brand11 from '../../public/image 38.png';
import brand12 from '../../public/image 39.png';
import brand13 from '../../public/bajaj-Photoroom.png';
import brand14 from '../../public/lubi.png';
import brand15 from '../../public/kirloskar-Photoroom.png';
import brand16 from '../../public/panasonic-Photoroom.png';
import brand17 from '../../public/solis-Photoroom.png';
import brand18 from '../../public/statcon-Photoroom.png';

export default function BrandCategories() {
  const [showAll, setShowAll] = useState(false);
  const [visibleIndexes, setVisibleIndexes] = useState([]);
  const [limit, setLimit] = useState(6);
  const router = useRouter();

  const brandItems = [
    { key: "adani", brand_img: brand1, name: "Adani" },
    { key: "waree", brand_img: brand2, name: "Waree" },
    { key: "tata", brand_img: brand3, name: "Tata Solar" },
    { key: "utl", brand_img: brand4, name: "UTL" },
    { key: "icon", brand_img: brand5, name: "Icon" },
    { key: "websol", brand_img: brand6, name: "Websol" },
    { key: "exide", brand_img: brand7, name: "Exide" },
    { key: "eastman", brand_img: brand8, name: "Eastman" },
    { key: "havells", brand_img: brand9, name: "Havells" },
    { key: "solax", brand_img: brand10, name: "Solax" },
    { key: "goodwe", brand_img: brand11, name: "GoodWe" },
    { key: "growwatt", brand_img: brand12, name: "Growwatt" },
    { key: "Bajaj", brand_img: brand13, name: "Bajaj" },
    { key: "Lubi", brand_img: brand14, name: "Lubi" },
    { key: "kirloskar", brand_img: brand15, name: "Kirloskar" },
    { key: "panasonic", brand_img: brand16, name: "Panasonic" },
    { key: "solis", brand_img: brand17, name: "Solis" },
    { key: "Statcon", brand_img: brand18, name: "Statcon" },
  ];

  useEffect(() => {
    const updateLimit = () => {
      if (window.innerWidth < 640) setLimit(2);
      else if (window.innerWidth < 1024) setLimit(4);
      else if (window.innerWidth < 1280) setLimit(4);
      else if(window.innerWidth <1536) setLimit(5);
      else setLimit(6);
    };
    updateLimit();
    window.addEventListener("resize", updateLimit);
    return () => window.removeEventListener("resize", updateLimit);
  }, []);

  const displayedBrands = showAll ? brandItems : brandItems.slice(0, limit);

  useEffect(() => {
    setVisibleIndexes([]);
    const timeout = setTimeout(() => {
      setVisibleIndexes(displayedBrands.map((_, idx) => idx));
    }, 50);
    return () => clearTimeout(timeout);
  }, [showAll, limit]);

  return (
    <div className="w-full flex flex-col xl:px-8 2xl:px-14 px-3 xl:py-14 2xl:py-14 py-8 transition-all duration-500">
      {/* Title */}
      <div className=" mb-4">
        <h2 className="text-[#3f3e3e] font-semibold text-lg">Popular Brands</h2>
      </div>

      {/* Grid */}
<div className="w-full  grid
  grid-cols-2 md:grid-cols-4 lg:grid-cols-5 2xl:grid-cols-6 
   transition-all duration-500 place-items-start 2xl:gap-x-14 xl:gap-x-20 lg:gap-x-6 md:gap-x-4 gap-x-3">
  
  {displayedBrands.map((data, index) => {
    const isVisible = visibleIndexes.includes(index);
    return (
      <div
        key={index}
        onClick={() => router.push(`/FilterProducts?brand=${data.name}`)}
        className={`cursor-pointer flex flex-col justify-center items-center 
          text-center transform transition-all duration-500 
          ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}
        style={{ transitionDelay: `${index * 30}ms` }}
      >
        {/* Image Box */}
        <div
  className="relative bg-[#EFEFEF] rounded-md flex justify-center items-center w-[173px] h-[173px] 
  aspect-[3/4] transition-all duration-300"
>
  <Image
    src={data.brand_img}
    alt={data.name}
    fill
    className="object-scale-down"
  />
</div>


        {/* Name */}
        <span className="text-sm sm:text-base md:text-lg text-[#363636] mt-2">{data.name}</span>
      </div>
    );
  })}
</div>


      {/* Toggle Button */}
      <div className="w-full flex justify-center items-center mt-4">
        <button
          onClick={() => setShowAll(!showAll)}
          className="text-blue-600 flex gap-1.5 items-center"
        >
          {showAll ? "View Less" : "View All"}
          <FaAngleDown
            className={`text-gray-400 transition-transform duration-300 ${showAll ? "rotate-180" : ""}`}
            size={20}
          />
        </button>
      </div>
    </div>
  );
}

